module.exports = __webpack_public_path__ + "static/krishna-reddy-012f4c2965334b177844ae4488ede19f.jpg";